import React from 'react';

import { WindowLocationService } from '~commonInfra/services/WindowLocationService';
import { isCurrentUrlViz } from '~commonInfra/url/UrlHelpers';

export const RemoveTrailingSlashWrapper: React.FunctionComponent<{}> = props => {
  const pathQueryFragment = WindowLocationService.getPathQueryFragment();
  const queryStartIndex = pathQueryFragment.indexOf('?');
  const lastCharInPathIndex = queryStartIndex > 0 ? queryStartIndex - 1 : pathQueryFragment.length - 1;

  if (!isCurrentUrlViz() && pathQueryFragment.charAt(lastCharInPathIndex) === '/') {
    const updatedPathQueryFragment = pathQueryFragment.substr(0, lastCharInPathIndex) + pathQueryFragment.substr(lastCharInPathIndex + 1);
    WindowLocationService.setPathQueryFragment(updatedPathQueryFragment);
  }

  return <>{props.children}</>;
};
